import React from 'react';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';

export function MobileCombinations({ showCardsImages, setShowCardsImages, winCombination, t }) {
  return (
    <>
      <div className='tb-g-mob-comb-switch' onClick={() => setShowCardsImages((prev) => !prev)}>
        <i className='icon-replace-belote' />
      </div>
      <div className='tb-g-mob-comb-ins'>
        {COMBINATIONS_PAYOUTS.map((item, index, arr) => {
          if (!index) {
            return (
              <div key={item.winType} className='tb-g-mob-comb-row'>
                <div
                  className={`tb-g-mob-comb-row-item ${
                    winCombination === item.winType ? 'active' : ''
                  }`}
                >
                  {showCardsImages ? (
                    <div className='tb-g-mob-comb-row-img'>
                      <img src={item.img} alt='' />
                    </div>
                  ) : (
                    <p className='tb-g-mob-comb-row-name'>{t(item.type)}</p>
                  )}
                  <p className='tb-g-mob-comb-row-coef'>x{item.odd}</p>
                </div>
              </div>
            );
          }
          if (index % 2) {
            return (
              <div key={item.winType} className='tb-g-mob-comb-row'>
                <div
                  className={`tb-g-mob-comb-row-item ${
                    winCombination === arr[index].winType ? 'active' : ''
                  }`}
                >
                  {showCardsImages ? (
                    <div className='tb-g-mob-comb-row-img'>
                      <img src={arr[index].img} alt='' />
                    </div>
                  ) : (
                    <p className='tb-g-mob-comb-row-name'>{t(arr[index].type)}</p>
                  )}
                  <p className='tb-g-mob-comb-row-coef'>x{arr[index].odd}</p>
                </div>
                <div
                  className={`tb-g-mob-comb-row-item ${
                    winCombination === arr[index + 1].winType ? 'active' : ''
                  }`}
                >
                  {showCardsImages ? (
                    <div className='tb-g-mob-comb-row-img'>
                      <img src={arr[index + 1].img} alt='' />
                    </div>
                  ) : (
                    <p className='tb-g-mob-comb-row-name'>{t(arr[index + 1].type)}</p>
                  )}
                  <p className='tb-g-mob-comb-row-coef'>x{arr[index + 1].odd}</p>
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
}
